import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsSettingsComponent } from './transport-interventions-settings.component';
import {DxPopupModule} from 'devextreme-angular';



@NgModule({
  declarations: [TransportInterventionsSettingsComponent],
    imports: [
        CommonModule,
        DxPopupModule
    ],
  exports: [TransportInterventionsSettingsComponent]
})
export class TransportInterventionsSettingsModule { }
